import { PricingPlan } from '@cyberlabrs/helpers';
import { ActiveSubscriptionResponseDto, SubscriptionStatusEnum } from '../commonTypes/organization.types';

export const checkPlanType = (planName: string, planType: PricingPlan, planTypeLowercase: string, metadata?: Record<string, any>): boolean => {
    const normalizedName = planName?.toLowerCase().trim();
    const metadataPlanType = metadata?.planType ? String(metadata.planType).toLowerCase().trim() : '';
    const metadataName = metadata?.name ? String(metadata.name).toLowerCase().trim() : '';

    return (
        planName === planType ||
        normalizedName === planTypeLowercase ||
        normalizedName?.includes(planTypeLowercase) ||
        metadataPlanType === planTypeLowercase ||
        metadataName === planTypeLowercase
    );
};

export const checkIsFree = (planName: string, metadata?: Record<string, any>): boolean => {
    return checkPlanType(planName, PricingPlan.FREE, 'free', metadata);
};

export const checkIsPremium = (planName: string, metadata?: Record<string, any>): boolean => {
    return checkPlanType(planName, PricingPlan.PREMIUM, 'premium', metadata);
};

export const checkIsEnterprise = (planName: string, metadata?: Record<string, any>): boolean => {
    return checkPlanType(planName, PricingPlan.ENTERPRISE, 'enterprise', metadata);
};

export const calculateTrialDaysRemaining = (activeSubscription: ActiveSubscriptionResponseDto | null): number => {
    if (!activeSubscription || !activeSubscription.endDate) return 0;

    const now = new Date();
    const endDate = new Date(activeSubscription.endDate);
    const diffTime = endDate.getTime() - now.getTime();
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    return diffDays;
};

export const isTrialExpired = (activeSubscription: ActiveSubscriptionResponseDto | null): boolean => {
    if (!activeSubscription) return false;

    if (activeSubscription.status === SubscriptionStatusEnum.EXPIRED) return true;

    const daysRemaining = calculateTrialDaysRemaining(activeSubscription);
    return daysRemaining < 0;
};

export const shouldDisplayTrialUI = (activeSubscription: ActiveSubscriptionResponseDto | null): boolean => {
    if (!activeSubscription) return false;

    if (activeSubscription.status !== SubscriptionStatusEnum.TRIAL) return false;

    return !isTrialExpired(activeSubscription);
};
